import { motion } from "framer-motion";

const groups = [
  {
    heading: "Board-Ready Competencies",
    items: [
      "CAPEX Governance & Capital Planning",
      "Stage-Gate & Front-End Loading (FFL)",
      "Enterprise Risk & Constraint Management",
      "Statutory / HSE / QA-QC Oversight",
      "Stakeholder & Promoter Alignment",
      "Board MIS, KPIs & Executive Dashboards",
      "Vendor, Tender & Contractual Governance",
      "Cash Flow, Budget & Variance Control",
    ],
  },
  {
    heading: "Technical & Delivery",
    items: [
      "Primavera P6 · Microsoft Project",
      "Critical Chain (CCPM) · Agile · Scrum",
      "SAP PM Module · Power BI",
      "PI Planning · Kanban Framework",
      "Commissioning · PSSR · RTO",
      "Six Sigma — Black / Yellow / Green / White",
      "Cybersecurity (ISC2) · Gen-AI (Oracle)",
      "EV Design (IIT Roorkee)",
    ],
  },
];

const item = {
  hidden: { opacity: 0, y: 24 },
  visible: (i) => ({
    opacity: 1, y: 0,
    transition: { duration: 0.6, delay: i * 0.04, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function Competencies() {
  return (
    <section id="practice" className="relative border-b border-surface-2">
      <div className="mx-auto max-w-[1440px] px-6 md:px-16 py-28 md:py-40">
        <div className="text-[11px] uppercase tracking-[0.28em] text-brass mb-10">
          <span className="tabular">04 —</span><span className="ml-3">Competencies</span>
        </div>
        <div className="grid grid-cols-12 gap-10 md:gap-16">
          {groups.map((g, gi) => (
            <div key={g.heading} className="col-span-12 md:col-span-6">
              <h3 className="font-serif-display text-ivory text-3xl md:text-4xl font-light leading-tight mb-8">
                {g.heading}
              </h3>
              <div className="hairline mb-4" />
              <ul>
                {g.items.map((it, i) => (
                  <motion.li
                    key={it}
                    custom={i}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-40px" }}
                    variants={item}
                    className="flex items-baseline justify-between py-4 border-b border-surface-2 group"
                  >
                    <span className="text-ivory font-light text-base md:text-lg">{it}</span>
                    <span className="tabular text-mutedfg text-xs group-hover:text-brass transition-colors duration-500">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </motion.li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
